import React, { useId, useState } from "react";
import eyeOpen from "@assets/img/eye-open.svg";
import eyeClose from "@assets/img/eye-close.svg";
import "./Input.sass";

const Input = ({
  label,
  showRequiredMark = false,
  type = "text",
  message,
  messageStatus = "default",
  status = "default",
  className = "",
  id,
  ...props
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const autoId = useId();
  const inputId = id || autoId;
  const messageId = `${inputId}-message`;

  const currentStatus = isFocused ? "focused" : status;

  const inputType =
    type === "password" && !isPasswordVisible ? "password" : "text";

  const containerClass = `input-container input-container--${currentStatus}`;
  const messageClass = `input-message input-message--${messageStatus}`;

  const hasValue = String(props.value ?? "").length > 0;

  const showRequiredPlaceholder =
    showRequiredMark && !isFocused && !hasValue;

  return (
    <div className={`input-wrapper ${className}`.trim()}>
      <div className={containerClass}>
        <input
          type={inputType}
          placeholder={showRequiredMark ? "" : label}
          className="input-field"
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          id={inputId}
          aria-label={label}
          aria-describedby={message ? messageId : undefined}
          {...props}
        />

        {showRequiredPlaceholder && (
          <span
            className="input-placeholder"
            aria-hidden="true"
          >
            <span>{label}</span>

            <span className="input-placeholder__required">
              *
            </span>
          </span>
        )}

        {type === "password" && (
          <button
            type="button"
            className="input-toggle"
            onClick={() =>
              setIsPasswordVisible((prevState) => !prevState)
            }
            aria-label={
              isPasswordVisible
                ? "Hide password"
                : "Show password"
            }
          >
            <img
              src={isPasswordVisible ? eyeOpen : eyeClose}
              alt="Toggle password visibility"
              className="input-toggle__icon"
            />
          </button>
        )}
      </div>

      {message && (
        <p
          id={messageId}
          className={messageClass}
        >
          {message}
        </p>
      )}
    </div>
  );
};

export default Input;
